/*
 * @Description:
 * @Author: PF
 * @Date: 2023-05-15 14:52:02
 * @LastEditors: PF
 * @LastEditTime: 2026-09-18 13:42:31
 */
// 菜单类别
export function getCdlb () {
  return {
    list: [{ value: 1, label: '教学应用服务' }, { value: 2, label: '决策支持应用服务' }, { value: 3, label: '管理应用服务' }, { value: 4, label: '文化生活应用服务' }, { value: 5, label: '科研应用服务' }, { value: 6, label: '公共服务' }, { value: 7, label: '社会服务' }, { value: 8, label: '智能预警服务' }]
  }
}
// 需求管理-需求类型
export function getXqglXqlx () {
  return {
    list: [{ value: 1, name: '需求' }, { value: 2, name: 'Bug' }],
    xq: 1,
    bug: 2
  }
}
// 需求管理-解决状态
export function getXqglJjzt () {
  return {
    list: [{ value: 0, name: '未解决' }, { value: 1, name: '进行中' }, { value: 2, name: '已解决' }, { value: 9, name: '已确认' }],
    wjj: 0,
    jxz: 1,
    yjj: 2,
    yqr: 9
  }
}

// 学籍异动类型
export function getXjydlx () {
  return {
    list: [{ value: 1, label: '公派留学' }, { value: 2, label: '留级' }, { value: 3, label: '降级' }, { value: 4, label: '跳级' }, { value: 5, label: '试读' }, { value: 6, label: '延长年限' }, { value: 7, label: '试读通过' }, { value: 8, label: '回国复学' }, { value: 11, label: '休学' }, { value: 12, label: '复学' }, { value: 13, label: '停学' }, { value: 14, label: '保留入学资格' }, { value: 15, label: '恢复入学资格' }, { value: 16, label: '取消入学资格' }, { value: 17, label: '恢复学籍' }, { value: 18, label: '取消学籍' }, { value: 19, label: '保留学籍' }, { value: 21, label: '转学(转出)' }, { value: 22, label: '转学(转入)' }, { value: 23, label: '转专业' }, { value: 29, label: '转班级' }, { value: 31, label: '退学' }, { value: 42, label: '开除学籍' }, { value: 51, label: '死亡' }, { value: 61, label: '提前毕业' }, { value: 62, label: '结业' }, { value: 63, label: '肄业' }, { value: 64, label: '国内访学' }, { value: 65, label: '国内访学后返校' }, { value: 99, label: '其他' }],
    gongPaiLiuXue: 1,
    liuJi: 2,
    jiangJi: 3,
    tiaoJi: 4,
    shiDu: 5,
    yanChangNianXian: 6,
    shiDuTongGuo: 7,
    huiGuoFuXue: 8,
    xiuXue: 11,
    fuXue: 12,
    tingXue: 13,
    baoLiuRuXueZiGe: 14,
    huiFuRuXueZiGe: 15,
    quXiaoRuXueZiGe: 16,
    huiFuXueJi: 17,
    quXiaoXueJi: 18,
    baoLiuXueJi: 19,
    zhuanXueZhuanChu: 21,
    zhuanXueZhuanRu: 22,
    zhuanZhuanYe: 23,
    zhuanBanJi: 29,
    tuiXue: 31,
    kaiChuXueJi: 42,
    siWang: 51,
    tiQianBiYe: 61,
    jieYe: 62,
    siYe: 63,
    guoNeiFangXue: 64,
    guoNeiFangXueHouFanXiao: 65,
    qiTa: 99
  }
}

// 学籍异动状态
export function getXjydxt () {
  return {
    list: [{ value: 0, label: '已录入' }, { value: 1, label: '已提交' }, { value: 9, label: '审批通过' }, { value: 10, label: '拒绝' }],
    yiLuRu: 0,
    yiTiJiao: 1,
    shenPiTongGuo: 9,
    juJue: 10
  }
}

// 教师教学工作要求类型
export function getJsjxgzyqlx () {
  return {
    list: [{ value: 1, label: '课前' }, { value: 2, label: '课后' }],
    keQian: 1,
    keHou: 2
  }
}

// 教师教学工作类型
export function getJsjxgzlx () {
  return {
    list: [{ value: 1, label: '教学设计' }, { value: 2, label: '课件' }, { value: 3, label: '作业' }],
    jiaoXueSheJi: 1,
    keJian: 2,
    zuoYe: 3
  }
}

// 新生学籍注册状况
export function getZczk () {
  return {
    list: [{ value: 0, name: '未注册' }, { value: 1, name: '注册' }, { value: 2, name: '报到' }, { value: 3, name: '未报到' }],
    weizhuce: 0,
    zhuce: 1,
    baodao: 2,
    weibaodao: 3
  }
}

// 学籍状态
export function getXjzt () {
  return {
    list: [{ value: 1, label: '在读' }, { value: 2, label: '休学' }, { value: 3, label: '退学' }, { value: 4, label: '停学' }, { value: 5, label: '复学' }, { value: 6, label: '流失' }, { value: 7, label: '毕业' }, { value: 8, label: '结业' }, { value: 9, label: '肄业' }, { value: 10, label: '转学' }, { value: 11, label: '死亡' }, { value: 12, label: '保留入学资格' }, { value: 13, label: '公派' }, { value: 14, label: '开除' }, { value: 15, label: '下落不明' }, { value: 21, label: '报名' }, { value: 22, label: '新生' }],
    zaidu: 1,
    xiuxue: 2,
    tuixue: 3,
    tingxue: 4,
    fuxue: 5,
    liushi: 6,
    biye: 7,
    jieye: 8,
    yiye: 9,
    zhuanxue: 10,
    siwang: 11,
    baoliuruxiezige: 12,
    gongpai: 13,
    kaichu: 14,
    xialuobuming: 15,
    baoming: 21,
    xinsheng: 22
  }
}

// 不在校学籍状态
export function getBzxXjzt () {
  return {
    list: [{ value: 3, label: '退学' }, { value: 7, label: '毕业' }, { value: 8, label: '结业' }, { value: 9, label: '肄业' }, { value: 10, label: '转学' }, { value: 11, label: '死亡' }, { value: 14, label: '开除' }, { value: 15, label: '下落不明' }],
    tuixue: 3,
    biye: 7,
    jieye: 8,
    yiye: 9,
    zhuanxue: 10,
    siwang: 11,
    kaichu: 14,
    xialuobuming: 15
  }
}

// 学制
export function getXz () {
  return {
    list: [{ value: 2, label: '两年' }, { value: 3, label: '三年' }, { value: 4, label: '四年' }, { value: 5, label: '五年' }, { value: 6, label: '六年' }, { value: 7, label: '七年' }, { value: 8, label: '八年' }, { value: 9, label: '九年' }],
    liangnian: 2,
    sannian: 3,
    sinian: 4,
    wunian: 5,
    liunian: 6,
    qinian: 7,
    banian: 8,
    jiunian: 9
  }
}

// 教学日志模板类型
export function getjxrzmbtx () {
  return {
    list: [{ value: 1, name: '文本' }, { value: 2, name: '单选' }, { value: 3, name: '多选' }],
    wenben: 1,
    danxuan: 2,
    duoxuan: 3
  }
}
// 药品购买人类型
export function getgmrlx () {
  return {
    list: [{ value: 1, name: '教职工' }, { value: 2, name: '学生' }, { value: 9, name: '其他' }],
    jiaozhigong: 1,
    xuesheng: 2,
    qita: 9
  }
}
// 课程类别
export function getkclb () {
  return {
    list: [{ value: 1, name: '理论' }, { value: 2, name: '实践' }, { value: 9, name: '理论和实践' }],
    lilun: 1,
    shijian: 2,
    lilunheshijain: 9
  }
}
// 课程分类
export function getkcfl () {
  return {
    gonggongxuanxiuke: '公共基础课',
    zhuanyexuanxiuke: '专业基础课',
    zhuanyehexinke: '专业核心课',
    tuijianxuanxiuke: '推荐（限定）选修课',
    renyixuanxiuke: '任意选修课',
    kechengshejiyushixi: '课程设计与实习',
    dinggangshixihuoshixun: '顶岗实习或实训',
    shehuishijian: '社会实践',
    junxun: '军训'
  }
}

// 选课方式
export function getxkfs () {
  return {
    list: [{ value: 1, name: '班主任代选' }, { value: 2, name: '自主选择' }],
    banzhurendaixuan: 1,
    zizhuxuanze: 2
  }
}
// 课程属性
export function getkcsx () {
  return {
    list: [{ value: 1, name: '任意选修课' }, { value: 2, name: '限定选修课' }],
    renyixuanxiuke: 1,
    xiandingxuanxiuke: 2
  }
}
// 申请状态
export function getsqzt () {
  return {
    list: [{ value: 0, name: '草稿' }, { value: 1, name: '流转中' }, { value: 9, name: '通过' }, { value: 10, name: '拒绝' }, { value: 11, name: '终止' }],
    caogao: 0,
    liuzhuanzhong: 1,
    tongguo: 9,
    jujue: 10,
    zhognzhi: 11
  }
}

// 考勤标志
export function getkqSign () {
  return {
    list: [{ value: 1, name: '正常' }, { value: 2, name: '异常' }, { value: 3, name: '迟到' }, { value: 4, name: '早退' }, { value: 5, name: '请假' }, { value: 6, name: '出差' }],
    zhengchang: 1,
    queqin: 2,
    chidao: 3,
    zaotui: 4,
    qingjia: 5,
    chuchai: 6
  }
}

// 调代课状态
export function gettdkzt () {
  return {
    list: [{ value: 0, name: '已录入' }, { value: 1, name: '处理中' }, { value: 9, name: '处理完成' }],
    yiluru: 0,
    chulizhong: 1,
    chuliwancheng: 9
  }
}

// 在校教职工状态
export function getZxjzg () {
  return {
    list: [{ value: 4, name: '返聘' }, { value: 11, name: '在职' }, { value: 12, name: '延聘' }, { value: 13, name: '待退休' }, { value: 14, name: '长病假' }, { value: 15, name: '因公出国' }, { value: 16, name: '停薪留职' }, { value: 17, name: '待岗' }],
    fanpin: 4,
    zaizhi: 11,
    yanpin: 12,
    daituixiu: 13,
    changbinjia: 14,
    yingongchuguo: 15,
    tingxinliuzhi: 16,
    daigang: 17
  }
}
// 不在校教职工状态
export function getBzx () {
  return {
    list: [{ value: 1, name: '退休' }, { value: 2, name: '离休' }, { value: 3, name: '死亡' }, { value: 5, name: '调出' }, { value: 6, name: '辞职' }, { value: 7, name: '离职' }, { value: 8, name: '开除' }, { value: 9, name: '下落不明' }, { value: 99, name: '其他' }, { value: 0, name: '空' }],
    tuixiu: 1,
    lixiu: 2,
    siwang: 3,
    diaochu: 5,
    cizhi: 6,
    lizhi: 7,
    kaichu: 8,
    xialuobuming: 9,
    qita: 99,
    null: 0
  }
}
// 教职工状态
export function getJzglt () {
  return {
    list: [{ value: 1, name: '退休' }, { value: 2, name: '离休' }, { value: 3, name: '死亡' }, { value: 4, name: '返聘' }, { value: 5, name: '调出' }, { value: 6, name: '辞职' }, { value: 7, name: '离职' }, { value: 8, name: '开除' }, { value: 9, name: '下落不明' }, { value: 11, name: '在职' }, { value: 12, name: '延聘' }, { value: 13, name: '待退休' }, { value: 14, name: '长病假' }, { value: 15, name: '因公出国' }, { value: 16, name: '停薪留职' }, { value: 17, name: '恢复学籍' }, { value: 99, name: '其他' }],
    tuixiu: 1,
    lixiu: 2,
    siwang: 3,
    diaochu: 5,
    cizhi: 6,
    lizhi: 7,
    kaichu: 8,
    xialuobuming: 9,
    qita: 99,
    null: 0
  }
}
// 作业类型
export function getZuoYeLeiXing () {
  return {
    list: [{ value: 1, name: '线下作业' }, { value: 2, name: '线上作业' }],
    xianXiaZuoYe: 1,
    xianShangZuoYe: 2
  }
}

// 月份
export function getYf () {
  return {
    list: [{ value: 1, label: '一月' }, { value: 2, label: '二月' }, { value: 3, label: '三月' }, { value: 4, label: '四月' }, { value: 5, label: '五月' }, { value: 6, label: '六月' }, { value: 7, label: '七月' }, { value: 8, label: '八月' }, { value: 9, label: '九月' }, { value: 10, label: '十月' }, { value: 11, label: '十一月' }, { value: 12, label: '十二月' }]
  }
}
// 星期
export function getXq () {
  return {
    list: [{ value: 2, label: '星期一' }, { value: 3, label: '星期二' }, { value: 4, label: '星期三' }, { value: 5, label: '星期四' }, { value: 6, label: '星期五' }, { value: 7, label: '星期六' }, { value: 1, label: '星期日' }],
    MON: 1,
    TUE: 2,
    WED: 3,
    THU: 4,
    FRI: 5,
    SAT: 6,
    SUN: 7

  }
}
// 获取中文星期 从一开始
export function getZwxq (val) {
  const week = ['', '一', '二', '三', '四', '五', '六', '日']
  return week[val]
}
// 获取中文星期 从零开始
export function getZwxqLing (val) {
  const week = ['一', '二', '三', '四', '五', '六', '日']
  return week[val]
}

// 网络课程状态
export function getWlkczt () {
  return {
    list: [{ value: -1, label: '私有' }, { value: 0, label: '待审核' }, { value: 9, label: '共享' }, { value: 10, label: '审核不通过' }],
    siyou: -1,
    daishenhe: 0,
    gongxiang: 9,
    shenhebutongguo: 10
  }
}

// 网络课程banner
export function getWlkcBanner () {
  return {
    list: [{ value: 1, label: '网络课程' }, { value: 2, label: '专业' }, { value: 3, label: '其他链接' }],
    wangluokecheng: 1,
    zhuanye: 2,
    qitalianjie: 3
  }
}

// 申请方式
export function getQjsrq () {
  return {
    list: [{ value: 1, label: '学生申请' }, { value: 2, label: '班主任申请' }, { value: 3, label: '直接录入' }],
    xueshengshenqing: 1,
    banzhurenshenqing: 2,
    jiazhangshenqing: 3
  }
}

// 实习方式
export function getSxfs () {
  return {
    list: [{ value: 1, label: '统一安排' }, { value: 2, label: '自主选择' }],
    tongyianpai: 1,
    zizhuxuanze: 2
  }
}

// 实习状态
export function getSxZt () {
  return {
    list: [{ value: 0, name: '未开始' }, { value: 1, name: '实习中' }, { value: 2, name: '实习结束' }],
    weiKaiShi: 0,
    shiXiZhong: 1,
    jieShu: 2
  }
}

// 发布状态
export function getFbzt () {
  return {
    list: [{ value: 0, label: '未发布' }, { value: 1, label: '已发布' }],
    weifabu: 0,
    yifabu: 1
  }
}

// 组织类型
export function getZzlx () {
  return {
    list: [{ value: 1, label: '党组织' }, { value: 2, label: '团组织' }, { value: 3, label: '工会组织' }, { value: 4, label: '学生会组织' }, { value: 5, label: '社团组织' }, { value: 6, label: '其他组织' }],
    dangzuzhi: 1,
    tuanzuzhi: 2,
    gonghuizuzhi: 3,
    xuexhenghuizuzhi: 4,
    shetuanzuzhi: 5,
    qitazuzhi: 6
  }
}
// 党组织级别
export function getDzzjb () {
  return {
    list: [{ value: 1, label: '党总支' }, { value: 2, label: '党支部' }, { value: 3, label: '党小组' }],
    dangzuzhi: 1,
    dangzhibu: 2,
    dangxiaozu: 3
  }
}
// 负责人类型
export function getFzrlx () {
  return {
    list: [{ value: 1, label: '教职工' }, { value: 2, label: '学生' }],
    jiaozhigong: 1,
    xuesheng: 2
  }
}
// 成员状态
export function getTcyzt () {
  return {
    list: [{ value: 1, label: '培养对象' }, { value: 2, label: '积极分子' }, { value: 3, label: '预备成员' }, { value: 4, label: '正式成员' }],
    peiyangduixiang: 1,
    jijifenzi: 2,
    yubeichengyuan: 3,
    zhengshichengyuan: 4
  }
}
// 党事务状态
export function getDswzt () {
  return {
    list: [{ value: 0, label: '未开始' }, { value: 1, label: '进行中' }, { value: 2, label: '结束' }],
    weikaishi: 0,
    jinxingzhong: 1,
    jieshu: 2
  }
}
// 参与人员标志
export function getCyrybz () {
  return {
    list: [{ value: 1, label: '指定人员' }, { value: 2, label: '所有教师' }, { value: 3, label: '所有学生' }, { value: 4, label: '所有组织人员' }],
    zhidingrenyuan: 1,
    suoyoujiaoshi: 2,
    suoyouxuesheng: 3,
    suoyouzuzhirenyuan: 4
  }
}
// 提交状态
export function getTjzt () {
  return {
    list: [{ value: 0, label: '未提交' }, { value: 1, label: '已提交' }],
    weitijiao: 0,
    yitijiao: 1
  }
}
// 参与人员提交状态
export function getCyrytjzt () {
  return {
    list: [{ value: 0, label: '未开始' }, { value: 1, label: '未提交' }, { value: 2, label: '已提交' }],
    weikaishi: 0,
    weitijiao: 1,
    yitijiao: 2
  }
}
// 考勤类型
export function getKqlx () {
  return {
    list: [{ value: 1, label: '纪律' }, { value: 2, label: '考勤' }],
    jilv: 1,
    kaoqin: 2
  }
}

// 巡检频率类型
export function getXjpllx () {
  return {
    list: [{ value: 1, label: '每月' }, { value: 2, label: '每周' }, { value: 3, label: '每日' }, { value: 4, label: '工作日' }],
    meiyue: 1,
    meizhou: 2,
    meiri: 3,
    gongzuori: 4
  }
}

// 完成策略状态
export function getWcclzt () {
  return {
    list: [{ value: 0, label: '未开始' }, { value: 1, label: '进行中' }, { value: 9, label: '已完成' }],
    weikaishi: 0,
    jinxingzhong: 1,
    yiwancheng: 9
  }
}
// 频次
export function getPc () {
  return {
    list: [{ value: 1, label: '周（校历）' }, { value: 2, label: '月' }, { value: 3, label: '学期' }],
    zhou: 1,
    yue: 2,
    xueqi: 3
  }
}
// 适用类型
export function getSylx () {
  return {
    list: [{ value: 1, label: '考试' }, { value: 2, label: '作业' }],
    kaoshi: 1,
    zuoye: 2
  }
}

// 课题状态
export function getKtzt () {
  return {
    list: [{ value: 0, label: '未开始' }, { value: 1, label: '进行中' }, { value: 2, label: '已完成' }],
    weikaishi: 0,
    jinxingzhong: 1,
    yiwancheng: 2
  }
}

// 培训资料学习状态
export function getPxzlXxzt () {
  return {
    list: [{ label: '未学习', value: 0 }, { label: '学习中', value: 1 }, { label: '已完成', value: 9 }],
    weixuexi: 0,
    xuexizhong: 1,
    yiwancheng: 9
  }
}

// 企业招聘状态
export function getQyzpzt () {
  return {
    list: [{ label: '未开始', value: 0 }, { label: '进行中', value: 1 }, { label: '已完成', value: 9 }],
    weikaishi: 0,
    jinxingzhong: 1,
    yiwancheng: 9
  }
}
// 预约记录通过状态
export function getYyjltgzt () {
  return {
    list: [{ label: '未审核', value: 0 }, { label: '审核不通过', value: 1 }, { label: '审核通过', value: 9 }],
    weishenhe: 0,
    shenhebutongguo: 1,
    shenhetongguo: 9
  }
}
// 信息发布状态
export function getXxfbzt () {
  return {
    list: [{ label: '未发布', value: 0 }, { label: '已发布', value: 9 }],
    weifabu: 0,
    yifabu: 9
  }
}

// 推荐登记状态
export function getTjdjzt () {
  return {
    list: [{ label: '未提交', value: 0 }, { label: '待审核', value: 1 }, { label: '审核不通过', value: 2 }, { label: '审核通过', value: 9 }],
    weitijiao: 0,
    daishenhe: 1,
    shenhebutongguo: 2,
    shenhetongguo: 9
  }
}
// 推荐审核状态
export function getTjshzt () {
  return {
    list: [{ label: '待审核', value: 1 }, { label: '未通过', value: 2 }, { label: '通过', value: 9 }],
    daishenhe: 1,
    weitongguo: 2,
    tongguo: 9
  }
}
// 预约管理预约状态
export function getYyglYyzt () {
  return {
    list: [{ label: '预约', value: 0 }, { label: '预约中', value: 1 }, { label: '待咨询', value: 9 }, { label: '咨询结束', value: 11 }],
    yuyue: 0,
    yuyuezhong: 1,
    daizixun: 9,
    zixunjiehsu: 11
  }
}
// 综合素质评价-发布状态
export function getZhszpjFbzt () {
  return {
    list: [{ label: '未发布', value: 0 }, { label: '已发布', value: 1 }, { label: '已结束', value: 9 }],
    weifabu: 0,
    yifabu: 1,
    yijieshu: 9
  }
}

// 查寝-出勤情况
export function getCqCqqk () {
  return {
    list: [{ label: '正常', value: 0 }, { label: '缺勤', value: 1 }, { label: '晚归', value: 2 }, { label: '请假（已离校）', value: 9 }],
    zhengchang: 0,
    queqin: 1,
    wangui: 2,
    qingjia: 9
  }
}

// 通知成员
export function getTzcy () {
  return {
    list: [{ label: '指定教师', value: 1 }, { label: '指定职务', value: 2 }, { label: '指定部门', value: 3 }, { label: '所有教师', value: 4 }, { label: '所有学生', value: 5 }, { label: '指定班级', value: 6 }, { label: '指定学生', value: 7 }, { label: '所有师生', value: 8 }],
    zhidingjiaoshi: 1,
    zhidingzhiwu: 2,
    zhidingbumen: 3,
    suoyoujiaoshi: 4,
    suoyouxuesheng: 5,
    zhidingbanji: 6,
    zhidingxuesheng: 7,
    suoyoushisheng: 8
  }
}

// 资料汇编-发布范围
export function getZlhbFbfw () {
  return {
    list: [{ label: '指定教师', value: 1 }, { label: '指定职务', value: 2 }, { label: '指定部门', value: 3 }, { label: '所有教师', value: 4 }],
    zhidingjiaoshi: 1,
    zhidingzhiwu: 2,
    zhidingbumen: 3,
    suoyoujiaoshi: 4
  }
}

// 宿舍-考勤类型
export function getSsKqlx () {
  return {
    list: [{ label: '入宿', value: 1 }, { label: '离宿', value: 2 }],
    rusu: 1,
    lisu: 2
  }
}

// 宿舍-考勤设备类型
export function getSsKqsblx () {
  return {
    list: [{ label: '人脸摄像头', value: 1 }, { label: '补录机', value: 2 }],
    renlianshexiangtou: 1,
    buluji: 2
  }
}

// 宿舍-考勤时间点类型
export function getSsKqSjdLx () {
  return {
    list: [{ label: '归宿', value: 1 }, { label: '清宿', value: 2 }],
    guisu: 1,
    qingsu: 2
  }
}

// 宿舍-考勤设备同步状态
export function getSsKqsbTbzt () {
  return {
    list: [{ label: '未同步', value: 0 }, { label: '等待同步', value: 1 }, { label: '同步中', value: 5 }, { label: '同步成功', value: 9 }, { label: '同步失败', value: 10 }],
    weitongbu: 0,
    dengdaitongbu: 1,
    tongbuzhong: 5,
    tongbuchenggong: 9,
    tongbushibai: 10
  }
}

// 宿舍-归宿状态
export function getSsKqGszt () {
  return {
    list: [{ label: '归宿', value: 1 }, { label: '未归', value: 2 }, { label: '晚归', value: 3 }, { label: '已补卡', value: 4 }, { label: '请假', value: 5 }],
    guisu: 1,
    weigui: 2,
    wangui: 3,
    buka: 4,
    qingjia: 5
  }
}

// 宿舍-清宿状态
export function getSsKqQszt () {
  return {
    list: [{ label: '离宿', value: 1 }, { label: '未离宿', value: 2 }, { label: '请假', value: 5 }],
    lisu: 1,
    weilisu: 2,
    qingjia: 5
  }
}

// 宿舍-考勤执行状态
export function getSsKqZxzt () {
  return {
    list: [{ label: '等待执行', value: 1 }, { label: '执行中', value: 2 }, { label: '执行成功', value: 9 }, { label: '执行失败', value: 10 }],
    dengdai: 1,
    zhixingzhong: 2,
    chenggong: 9,
    shibai: 5
  }
}

// 毕业去向-字段类型
export function getByqxZdlx () {
  return {
    list: [{ label: '单行文本', value: 1 }, { label: '多行文本', value: 2 }, { label: '下拉框', value: 6 }, { label: '日期', value: 7 }],
    danhang: 1,
    duohang: 2,
    xialakuang: 6,
    riqi: 7
  }
}

// 考评人身份
export function getKprsf () {
  return {
    list: [{ label: '教师', value: 1 }, { label: '学生', value: 2 }],
    jiaoshi: 1,
    xuesheng: 2
  }
}

// 考评人
export function getKpr () {
  return {
    list: [{ label: '本班学生', value: 1 }, { label: '授课班级学生', value: 2 }],
    benban: 1,
    shoukeban: 2
  }
}

// 考核状态
export function getKhzt () {
  return {
    list: [{ label: '待提交', value: 0 }, { label: '待审核', value: 1 }, { label: '待启动', value: 5 }, { label: '进行中', value: 6 }, { label: '已完成', value: 7 }, { label: '审核通过', value: 9 }, { label: '审核不通过', value: 10 }],
    daitijiao: 0,
    daishenhe: 1,
    daiqidong: 5,
    jinxingzhong: 6,
    yiwancheng: 7,
    tongguo: 9,
    jujue: 10
  }
}

// 财务预算状态
export function getCwysZt () {
  return {
    list: [{ label: '已提交', value: 0 }, { label: '审批中', value: 1 }, { label: '通过', value: 9 }, { label: '拒绝', value: 10 }],
    tijiao: 0,
    shenpi: 1,
    tongguo: 9,
    jujue: 10
  }
}

// 订餐状态
export function getCyDczt () {
  return {
    list: [{ label: '未提交', value: 0 }, { label: '已提交', value: 1 }, { label: '已取消', value: 2 }],
    weitijiao: 0,
    yitijiao: 1,
    yiquxiao: 2
  }
}

// 教案生成状态
export function getJiaoAnShengCheng () {
  return {
    list: [
      { label: '生成中', value: 1 },
      { label: '已完成', value: 2 },
      { label: '失败', value: 3 }
    ],
    jinxing: 1,
    wancheng: 2,
    shibai: 3
  }
}

// 教案知识库
export function getJiaoAnZhiSHiKu () {
  return {
    list: [
      { value: 'outline', label: '大纲' },
      { value: 'excellent', label: '优秀教案' },
      { value: 'textbook', label: '教材' },
      { value: 'other', label: '其他' }
    ],
    dagang: 'outline',
    youxiu: 'excellent',
    jiaocai: 'textbook',
    qita: 'other'
  }
}

// 招生预警级别：1-黄色预警,2-红色预警
export function getZhaoshengYujingJb () {
  return {
    list: [
      { value: 1, label: '黄色预警' },
      { value: 2, label: '红色预警' }
    ],
    huangse: 1,
    hongse: 2
  }
}
// 预警维度：1-招生计划,2-招生区域,3-招生渠道
export function getZhaoshengYujingWd () {
  return {
    list: [
      { value: 1, label: '招生计划' },
      { value: 2, label: '招生区域' },
      { value: 3, label: '招生渠道' }
    ],
    zhaoshengjihua: 1,
    zhaoshengquyu: 2,
    zhaoshengqudao: 3
  }
}
